import {RECEIVE_AUTHOR} from "../actions/historyActions";

export default function (state = null, action) {
    switch (action.type) {
        case RECEIVE_AUTHOR:
            return action.payload;
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/recommendations/authorReducers.js
 **/